import { InjectionToken } from '@angular/core';
import { type IGetSampleAiAnalysisProgressUseCase } from '@analysis/use-cases';

export const GET_SAMPLE_AI_ANALYSIS_PROGRESS_QUERY = new InjectionToken<IGetSampleAiAnalysisProgressUseCase>(
  'GET_SAMPLE_AI_ANALYSIS_PROGRESS_QUERY'
);
